import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GenericButton from '../updated/shared/Button';
import './VerificationTypeSelection.css';

interface VerificationTypeSelectionProps {
  theme: any;
  onClose?: () => void;
}

const VerificationTypeSelection: React.FC<VerificationTypeSelectionProps> = ({ theme, onClose }) => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState<string | null>(null);

  useEffect(() => {
    // Get userType from localStorage
    const currentUserType = localStorage.getItem('userType');
    setUserType(currentUserType);

    // Listen for userType changes
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'userType') {
        setUserType(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Poll for changes in same tab
    const pollInterval = setInterval(() => {
      const current = localStorage.getItem('userType');
      if (current !== userType) {
        setUserType(current);
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(pollInterval);
    };
  }, [userType]);

  const handleKycClick = () => {
    navigate('/indexx-exchange/verify-with-indexx');
    if (onClose) onClose();
  };

  const handleKybClick = () => {
    navigate('/indexx-exchange/kyb-verification');
    if (onClose) onClose();
  };

  return (
    <div className="verification-type-selection">
      <div className="verification-type-header">
        <h2 className="verification-type-title" style={{ color: theme.palette.text.primary }}>
          Choose Verification Type
        </h2>
        <p className="verification-type-description" style={{ color: theme.palette.text.secondary }}>
          Select the type of verification that matches your account type. Individual users should complete KYC, while businesses should complete KYB.
        </p>
      </div>

      <div className="verification-type-buttons">
        <div className="verification-type-card">
          <div className="verification-type-card-header">
            <h3 className="verification-type-card-title" style={{ color: theme.palette.text.primary }}>
              Individual User KYC
            </h3>
            <p className="verification-type-card-description" style={{ color: theme.palette.text.secondary }}>
              Complete Know Your Customer (KYC) verification for personal accounts. This includes identity verification, document upload, and personal information submission.
            </p>
          </div>
          <GenericButton
            text="Start KYC Verification"
            onClick={handleKycClick}
            className="verification-type-button"
            styles={{
              backgroundColor: (userType === 'CaptainBee' || localStorage.getItem('userType') === 'CaptainBee') ? '#FFBB00' : '#11BE6A',
              color: '#fff',
              width: '100%',
              marginTop: '20px',
            }}
            IconComponent={undefined}
            disabled={false}
            loading={false}
          />
        </div>

        <div className="verification-type-card">
          <div className="verification-type-card-header">
            <h3 className="verification-type-card-title" style={{ color: theme.palette.text.primary }}>
              KYB for Business
            </h3>
            <p className="verification-type-card-description" style={{ color: theme.palette.text.secondary }}>
              Complete Know Your Business (KYB) verification for business accounts. This includes company information, business documents, and authorized representative verification.
            </p>
          </div>
          <GenericButton
            text="Start KYB Verification"
            onClick={handleKybClick}
            className="verification-type-button"
            styles={{
              backgroundColor: (userType === 'CaptainBee' || localStorage.getItem('userType') === 'CaptainBee') ? '#FFBB00' : '#11BE6A',
              color: '#fff',
              width: '100%',
              marginTop: '20px',
            }}
            IconComponent={undefined}
            disabled={false}
            loading={false}
          />
        </div>
      </div>
    </div>
  );
};

export default VerificationTypeSelection;

